<template>
  <b-modal
   id="cc-add-order-modal"
   centered
   title="Cart Details"
   ref="addOrderModal"
   @shown="initForm"
   size="lg">
   <b-form> 
    <b-row>
      <b-col md="4">
        <b-form-group label="First Name" label-class="main-label"></b-form-group>
      </b-col>
      <b-col md="8">
        <b-form-group>
          <b-form-input v-model="form.first_name" placeholder="Enter First Name"></b-form-input>
          <b-form-invalid-feedback :force-show="hasError('first_name')">{{ errorMessage('first_name') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Last Name" label-class="main-label"></b-form-group>
      </b-col>
      <b-col md="8">
        <b-form-group>
          <b-form-input v-model="form.last_name" placeholder="Enter Last Name"></b-form-input>
          <b-form-invalid-feedback :force-show="hasError('last_name')">{{ errorMessage('last_name') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Mobile Number" label-class="main-label"></b-form-group>
      </b-col>
      <b-col md="8">
        <b-form-group>
          <b-input-group prepend="+63">
            <b-form-input
              v-model="form.mobile"
              inputmode="numeric"
              maxlength="10"
              pattern="[0-9]*"
              autocomplete="off"
              @keypress.native="filterMobile"
              placeholder="Enter Mobile Number">
            </b-form-input>
          </b-input-group>
          <b-form-invalid-feedback :force-show="hasError('mobile')">{{ errorMessage('mobile') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="Email Address" label-class="main-label"></b-form-group>
      </b-col>
      <b-col md="8">
        <b-form-group>
          <b-form-input v-model="form.email" placeholder="Enter Email Address"></b-form-input>
          <b-form-invalid-feedback :force-show="hasError('email')">{{ errorMessage('email') }}</b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-row>
   </b-form>
   <template slot="modal-footer">
    <b-button variant="ghost" class="btn-cancel" @click="$root.$emit('bv::hide::modal', 'cc-add-order-modal')">Cancel</b-button>
    <b-button
      variant="primary"
      :disabled="isContinueDisabled || loading.register"
      @click="createOrder">
      Continue
    </b-button>
   </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  data() {
    return {
      form: {}
    }
  },
  computed: {
    ...mapGetters({
      newOrderDetails: "conversationalCommerce/newOrderDetails",
      errors: "conversationalCommerce/errors",
      loading: "conversationalCommerce/loading"
    }),
    isContinueDisabled: {
      get() {
        const requiredFields = ['first_name', 'last_name'];
        return requiredFields.map(field => {
          return !this.form[field];
        }).includes(true);
      },
      set(status) {
        return status;
      }
    }
  },
  methods: {
    initForm() {
      this.$store.commit("conversationalCommerce/resetNewOrderDetails");
      this.form = this.newOrderDetails;
      this.$store.commit("conversationalCommerce/setErrors", null);
    },
    isNotNumeric(input) {
      return /[^0-9]/g.test(input);
    },
    filterMobile(e) {
      if (!this.form.mobile && String.fromCharCode(e.keyCode) !== '9') e.preventDefault();
      if (this.isNotNumeric(String.fromCharCode(e.keyCode))) e.preventDefault();
    },
    isValidEmail (email) {
      const isEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/; //eslint-disable-line
      return isEmail.test(email);
    },
    async createOrder() {
      const errors = {};
      const fields = Object.keys(this.form);
      const required_fields = ['first_name', 'last_name'];
      fields.forEach(field => {
        if (required_fields.includes(field) && !this.form[field]) errors[field] = 'This is a required field.';
        else if (field === 'mobile' && this.form[field] && (this.form[field].length < 10 || this.isNotNumeric(this.form[field]))) errors[field] = 'Please enter a valid mobile number.';
        else if (field === 'email' && this.form[field] && !this.isValidEmail(this.form[field])) errors[field] = 'Please enter a valid email address.';
      });

      if (_.isEmpty(errors)) {
        const payload = { ...this.form };
        if (this.form.mobile) payload['mobile'] = `0${this.form.mobile}`;
        await this.$store.dispatch('conversationalCommerce/registGuestUser', payload);
        if (_.isEmpty(this.errors)) {
          this.$root.$emit('bv::hide::modal', 'cc-add-order-modal');
          this.$store.commit('conversationalCommerce/resetNewOrderDetails');
        }
      } else this.$store.commit('conversationalCommerce/setErrors', errors);
    },
    hasError(field) {
      return this.errors && field in this.errors ? true : false;
    },
    errorMessage(field) {
      return this.errors ? this.errors[field] : "";
    }
  }
}
</script>

<style lang="scss">
#cc-add-order-modal {
  * {
    font-family: MainFontRegular, sans-serif;
  }
  .close {
    font-family: MainFontRegular, sans-serif;
  }
}
</style>
